import fetchCycle from '../fetchCycle'

import {MiddlewareType} from 'middlewares'
import {
  offerCheck,
  offerCheckDone,
  offerCheckError,
  offerCheckFatalError,
  offerCheckPending
} from 'modules/offerCheck/slice'
import {fatalError} from 'modules/common/actions/fatalError'

import Psd2 from 'services/psd2'
import {ServerCode} from 'services/psd2/types'

import {determinePreBookingSubmitApiKey} from 'utils/determineApiKeys'
import {urlParams} from 'utils/urlParams'
import {validateOfferCheckUrl} from 'modules/offerCheck/validation'
import {logToDataDog} from 'services/datadogLogger'
import timing from 'utils/timing'
import {offerCheckService} from 'services/offerCheck'
import logBoFHService, {
  BoFHServiceEndpointNames,
  BoFHServiceStatus
} from 'performance/logBoFHService'
import {getHttpRequestId} from 'modules/common/selectors'
import captureException from 'utils/captureException'

const requestsTiming = timing()

const middleware: MiddlewareType = store => next => action => {
  const {dispatch, getState} = store
  const state = getState()
  const httpRequestId = getHttpRequestId(state)

  next(action)

  switch (action.type) {
    case offerCheck.type: {
      // eslint-disable-next-line fp/no-mutation
      const experimentApiKey = determinePreBookingSubmitApiKey()

      const offerCheckUrl = action.payload.url
      const {providerCode} = urlParams()

      // TODO (Checkout) [2022-07-01]: Replace with booking type value (assisted booking or MOR) if becomes available via SAPI
      const validateMorParams = providerCode !== 'EPS' && providerCode !== 'PPN'

      const {isValid, validationErrors} = validateOfferCheckUrl(
        offerCheckUrl,
        validateMorParams
      )

      if (!isValid) {
        logToDataDog({
          logName: 'OfferCheckInvalidUrlParams',
          metadata: {
            offerCheckUrl,
            errors: validationErrors
          },
          level: 'error'
        })

        validationErrors.forEach(validationError => {
          console.warn(validationError.message)
        })
      }

      requestsTiming.start('offerCheck')

      fetchCycle(
        dispatch,
        offerCheckService(action.payload, experimentApiKey, httpRequestId),
        offerCheckPending,
        offerCheckDone,
        offerCheckError,
        offerCheckFatalError
      )

      logBoFHService(
        BoFHServiceEndpointNames.OfferCheck,
        BoFHServiceStatus.start,
        {params: action.params}
      )
      break
    }

    case offerCheckError.type: {
      const timings = requestsTiming.stop('offerCheck')
      logBoFHService(
        BoFHServiceEndpointNames.OfferCheck,
        BoFHServiceStatus.error,
        {
          error: action?.payload?.response?.data,
          timings,
          request_id: action?.headers?.['x-request-id']
        },
        'error'
      )
      break
    }

    case offerCheckFatalError.type: {
      const timings = requestsTiming.stop('offerCheck')
      logBoFHService(
        BoFHServiceEndpointNames.OfferCheck,
        BoFHServiceStatus.fatalError,
        {
          response: action?.payload?.toJSON(),
          timings
        },
        'error'
      )
      captureException(action?.payload)
      dispatch(fatalError(action?.payload))
      break
    }

    case offerCheckDone.type: {
      const timings = requestsTiming.stop('offerCheck')
      logBoFHService(
        BoFHServiceEndpointNames.OfferCheck,
        BoFHServiceStatus.done,
        {timings, request_id: action?.payload?.headers?.['x-request-id']}
      )

      const {providerCode} = urlParams()
      if (providerCode === ServerCode.Eps) {
        const Psd2Provider = Psd2.getProvider(ServerCode.Eps)
        Psd2Provider.beforeBooking()
      }

      break
    }

    default:
      break
  }
}

export default middleware
